import { useState } from "react";
import { motion } from "framer-motion";
import { SectionHead, Reveal } from "./Reveal";
import { TALENT_MAP, SECTORS } from "../content";

export const TalentMap = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="talent-map" className="relative py-28 md:py-36 bg-[#0d1013] border-y border-white/10" data-testid="talent-map-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <SectionHead
            index="04"
            label="Our talent map"
            title={<>Leadership and functional roles across the <em className="text-emerald-400">BFSI value chain.</em></>}
          />
          <Reveal className="flex flex-wrap gap-2 lg:max-w-sm lg:justify-end">
            {SECTORS.map((s) => (
              <span key={s} className="rounded-full border border-emerald-400/30 bg-emerald-400/5 px-4 py-1.5 font-mono text-xs uppercase tracking-[0.15em] text-emerald-300">
                {s}
              </span>
            ))}
          </Reveal>
        </div>
        <div className="mt-16 grid grid-cols-1 border-t border-white/10 md:grid-cols-3">
          {TALENT_MAP.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1} className="h-full">
              <div
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`relative h-full cursor-default border-b md:border-b-0 border-white/10 py-10 md:px-8 ${i > 0 ? "md:border-l" : "md:pl-0"} transition-colors duration-500`}
                data-testid={`talent-tier-${i}`}
              >
                <motion.span
                  className="absolute left-0 top-0 h-[2px] bg-emerald-400"
                  initial={false}
                  animate={{ width: active === i ? "100%" : "0%" }}
                  transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                />
                <p className="font-mono text-xs tracking-[0.2em] text-zinc-400">{t.tier}</p>
                <p className={`font-display mt-4 text-4xl transition-colors duration-500 ${active === i ? "text-emerald-300" : "text-zinc-100"}`}>{t.name}</p>
                <ul className="mt-8 space-y-3">
                  {t.roles.map((r) => (
                    <li key={r} className="flex items-start gap-3 text-[15px] text-zinc-300">
                      <span className={`mt-2 h-1.5 w-1.5 shrink-0 rounded-full transition-colors duration-500 ${active === i ? "bg-emerald-400" : "bg-zinc-500"}`} />
                      {r}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
